import { SHOW_MAPPING, HIDE_MAPPING } from "../actions/types";

const initialProgress = {
  showMapping: false,
};

//Handling User
export const mappingReducer = (state = initialProgress, { type }) => {
  switch (type) {
    case SHOW_MAPPING:
      return {
        showMapping: true,
      };
    case HIDE_MAPPING:
      return {
        showMapping: false,
      };
    default:
      return state;
  }
};
